import { ref, watch, onMounted, onBeforeUnmount, Ref } from 'vue'
import { readBindingReminder, postponeBindingReminder } from './wechatBindingReminder'

// 自动改密提醒与微信提醒使用相同的24小时/第三次稍后7天规则，存储空间独立。
export function usePasswordReminder(identity:()=>string, path:()=>string, homes:string[], visible:Ref<boolean>, prepare:(first:boolean)=>void) {
 const automatic=ref(false)
 const key=()=>identity()?'password-reminder:v1:'+identity():''
 let memory:any={},timer:ReturnType<typeof setInterval>|undefined
 function read(){try{return JSON.parse(localStorage.getItem(key())||JSON.stringify(memory))}catch{return memory}}
 function save(value:any){memory=value;if(key())try{localStorage.setItem(key(),JSON.stringify(value))}catch{/* 当前会话继续抑制。 */}}
 function present(){
  if(!key() || visible.value || !homes.includes(path()) || document.visibilityState==='hidden')return
  const state=read(),until=readBindingReminder(localStorage,key()).until || memory.until || 0
  if(!state.pending || until>Date.now() || /INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName||''))return
  if(Array.from(document.querySelectorAll('.ant-modal-wrap,.ant-drawer-open')).some(el=>el.getClientRects().length>0&&getComputedStyle(el).visibility!=='hidden'))return
  prepare(state.first===true);automatic.value=true;visible.value=true
  const record=postponeBindingReminder(localStorage,key(),Date.now(),false);save({...state,...record})
 }
 function request(first=false){if(!key())return;save({...read(),pending:true,first});present()}
 function later(){
  if(automatic.value && key()){const state=read(),record=postponeBindingReminder(localStorage,key());save({...state,...record})}
  automatic.value=false;visible.value=false
 }
 function manual(){automatic.value=false}
 function clear(){if(key())try{localStorage.removeItem(key())}catch{/* 不影响改密成功后的当前会话。 */}memory={};automatic.value=false;visible.value=false}
 watch(identity,()=>{if(automatic.value)visible.value=false;automatic.value=false;memory={};present()})
 watch(path,()=>{if(automatic.value&&!homes.includes(path())){visible.value=false;automatic.value=false}present()})
 const refresh=()=>present()
 onMounted(()=>{timer=setInterval(present,4000);window.addEventListener('focus',refresh);window.addEventListener('storage',refresh);document.addEventListener('visibilitychange',refresh);present()})
 onBeforeUnmount(()=>{clearInterval(timer);window.removeEventListener('focus',refresh);window.removeEventListener('storage',refresh);document.removeEventListener('visibilitychange',refresh)})
 return {automatic,request,later,manual,clear}
}
